/* eslint import/no-extraneous-dependencies: 0 */
/* eslint no-underscore-dangle: 0 */
/* eslint max-len: 0 */
import * as Blockly from 'blockly';
import { FieldAngle } from '@blockly/field-angle';

// El plugin @blockly/field-angle no reproduce el tamaño ni el arrastre de prod, y usa `FieldAngle.HALF`
// de la clase importada en sus métodos, así que pisar una static no alcanza: dropdownCreate y
// updateGraph se reescriben enteros con las constantes del FieldAngle legacy.
const HALF = 60;
const HANDLE_RADIUS = 10;
const RADIUS = HALF - HANDLE_RADIUS - 1;
const CENTER_RADIUS = 2;
const ARROW_WIDTH = HANDLE_RADIUS;
const OFFSET = 90;
const CLOCKWISE = true;

// Data-URI inline, no un href a public/images: con la referencia externa el ícono se veía distinto.
const ARROW_SVG_DATAURI = 'data:image/svg+xml;base64,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';

export class AngleDialField extends FieldAngle {
  // WidgetDiv.show() registra un focus loss handler que cierra el selector apenas se abre; se anula
  // durante super.showEditor_() (mismo fix que modalField.js). El popup toma el color del bloque
  // padre, no del shadow, como en prod.
  showEditor_(e) {
    const focusManager = Blockly.getFocusManager();
    const originalRegister = focusManager.registerPopoverFocusLossHandler.bind(focusManager);
    focusManager.registerPopoverFocusLossHandler = () => {};
    try {
      super.showEditor_(e);
    } finally {
      focusManager.registerPopoverFocusLossHandler = originalRegister;
    }
    const sourceBlock = this.getSourceBlock();
    const parent = sourceBlock && sourceBlock.getParent && sourceBlock.getParent();
    if (parent && parent.style) {
      Blockly.DropDownDiv.setColour(parent.style.colourPrimary, sourceBlock.style.colourTertiary);
    }
  }

  // No llama a super: el plugin mueve el brazo con solo pasar el mouse; acá, como en prod, solo se
  // arrastra si el mousedown arranca en la manija.
  dropdownCreate() {
    const svg = Blockly.utils.dom.createSvgElement(Blockly.utils.Svg.SVG, {
      xmlns: Blockly.utils.dom.SVG_NS,
      'xmlns:html': Blockly.utils.dom.HTML_NS,
      'xmlns:xlink': Blockly.utils.dom.XLINK_NS,
      version: '1.1',
      height: `${HALF * 2}px`,
      width: `${HALF * 2}px`,
    });

    Blockly.utils.dom.createSvgElement(
      Blockly.utils.Svg.CIRCLE,
      { cx: HALF, cy: HALF, r: RADIUS, class: 'blocklyAngleCircle' },
      svg,
    );
    this.gauge_ = Blockly.utils.dom.createSvgElement(
      Blockly.utils.Svg.PATH,
      { class: 'blocklyAngleGauge' },
      svg,
    );
    this.line_ = Blockly.utils.dom.createSvgElement(
      Blockly.utils.Svg.LINE,
      { x1: HALF, y1: HALF, class: 'blocklyAngleLine' },
      svg,
    );

    const offsetRad = (Math.PI * OFFSET) / 180;
    Blockly.utils.dom.createSvgElement(
      Blockly.utils.Svg.LINE,
      {
        x1: HALF,
        y1: HALF,
        x2: HALF + RADIUS * Math.cos(offsetRad),
        y2: HALF - RADIUS * Math.sin(offsetRad),
        class: 'blocklyAngleLine',
      },
      svg,
    );

    for (let deg = 0; deg < 360; deg += 15) {
      Blockly.utils.dom.createSvgElement(
        Blockly.utils.Svg.LINE,
        {
          x1: HALF + RADIUS - 13,
          y1: HALF,
          x2: HALF + RADIUS - 7,
          y2: HALF,
          class: 'blocklyAngleMarks',
          transform: `rotate(${deg},${HALF},${HALF})`,
        },
        svg,
      );
    }

    Blockly.utils.dom.createSvgElement(
      Blockly.utils.Svg.CIRCLE,
      { cx: HALF, cy: HALF, r: CENTER_RADIUS, class: 'blocklyAngleCenterPoint' },
      svg,
    );

    // cursor en el grupo (no solo en el círculo, como el legacy) para que la flecha también se vea
    // clickeable: todo el grupo responde al mousedown.
    this.handle_ = Blockly.utils.dom.createSvgElement(
      Blockly.utils.Svg.G,
      { cursor: 'pointer' },
      svg,
    );
    Blockly.utils.dom.createSvgElement(
      Blockly.utils.Svg.CIRCLE,
      { cx: 0, cy: 0, r: HANDLE_RADIUS, class: 'blocklyAngleDragHandle' },
      this.handle_,
    );
    this.arrowSvg_ = Blockly.utils.dom.createSvgElement(
      Blockly.utils.Svg.IMAGE,
      {
        width: ARROW_WIDTH,
        height: ARROW_WIDTH,
        x: -ARROW_WIDTH / 2,
        y: -ARROW_WIDTH / 2,
      },
      this.handle_,
    );
    this.arrowSvg_.setAttributeNS(Blockly.utils.dom.XLINK_NS, 'xlink:href', ARROW_SVG_DATAURI);

    this.mouseDownWrapper_ = Blockly.browserEvents.bind(this.handle_, 'mousedown', this, this.onDialMouseDown_);

    this.updateGraph();
    return svg;
  }

  onDialMouseDown_() {
    // Limpia listeners de un drag anterior: si quedan colgados de document.body, el próximo mousemove
    // revienta contra this.gauge_ nulo y corta el gesture que abre el selector.
    this.onDialMouseUp_();
    this.mouseMoveWrapper_ = Blockly.browserEvents.bind(document.body, 'mousemove', this, this.onDialMouseMove_);
    this.mouseUpWrapper_ = Blockly.browserEvents.bind(document.body, 'mouseup', this, this.onDialMouseUp_);
  }

  onDialMouseUp_() {
    if (this.mouseMoveWrapper_) Blockly.browserEvents.unbind(this.mouseMoveWrapper_);
    if (this.mouseUpWrapper_) Blockly.browserEvents.unbind(this.mouseUpWrapper_);
    this.mouseMoveWrapper_ = null;
    this.mouseUpWrapper_ = null;
  }

  // Divergencia deliberada con el legacy: el arrastre va de a 1 grado, no de a 15 (pedido de QA).
  // setValue() corre el validator propio de cada bloque, que es el que limita el rango.
  onDialMouseMove_(e) {
    if (!this.gauge_) {
      this.onDialMouseUp_();
      return;
    }
    e.preventDefault();
    const rect = this.gauge_.ownerSVGElement.getBoundingClientRect();
    const dx = e.clientX - rect.left - HALF;
    const dy = e.clientY - rect.top - HALF;
    let angle = Math.atan(-dy / dx);
    if (Number.isNaN(angle)) return;
    angle = Blockly.utils.math.toDegrees(angle);
    if (dx < 0) {
      angle += 180;
    } else if (dy > 0) {
      angle += 360;
    }
    angle = CLOCKWISE ? OFFSET + 360 - angle : angle - OFFSET;
    angle = Math.round(angle);
    this.setValue(angle);
    // Con el editor abierto, setValue() no actualiza el <input> visible: se empuja a mano para que
    // siga al mouse durante el arrastre.
    const committed = this.getValue();
    if (this.htmlInput_) this.htmlInput_.value = committed;
    this.updateGraph();
  }

  // Lee getValue(), no getText(): en v13, con el editor abierto, getText() queda desactualizado.
  updateGraph() {
    if (!this.gauge_) return;
    const value = Number(this.getValue());
    const a = (value % 360) + OFFSET;
    const bStart = Blockly.utils.math.toRadians(a);
    let path = `M ${HALF},${HALF}`;
    let d = HALF;
    let e = HALF;
    if (!Number.isNaN(bStart)) {
      const f = Blockly.utils.math.toRadians(OFFSET);
      const g = Math.cos(f) * RADIUS;
      const h = Math.sin(f) * -RADIUS;
      const b = CLOCKWISE ? 2 * f - bStart : bStart;
      d += Math.cos(b) * RADIUS;
      e -= Math.sin(b) * RADIUS;
      const largeArcFlag = Math.abs(a - OFFSET) > 180 ? 1 : 0;
      let sweepFlag = Number(CLOCKWISE);
      if (a < OFFSET) sweepFlag = 1 - sweepFlag;
      path += ` l ${g},${h} A ${RADIUS},${RADIUS} 0 ${largeArcFlag} ${sweepFlag} ${d},${e} z`;
      if (this.arrowSvg_) {
        this.arrowSvg_.setAttribute('transform', `rotate(${CLOCKWISE ? a + 2 * OFFSET : -a})`);
      }
    }
    this.gauge_.setAttribute('d', path);
    this.line_.setAttribute('x2', d);
    this.line_.setAttribute('y2', e);
    this.handle_.setAttribute('transform', `translate(${d},${e})`);
  }

  dropdownDispose() {
    if (this.mouseDownWrapper_) Blockly.browserEvents.unbind(this.mouseDownWrapper_);
    this.onDialMouseUp_();
    this.gauge_ = null;
    this.line_ = null;
    this.handle_ = null;
    this.arrowSvg_ = null;
  }
}

Blockly.Css.register(`
.blocklyAngleCircle {
  stroke: none;
  fill: #000;
  /* El plugin base registra su propio .blocklyAngleCircle con
     fill-opacity:0.8 (pensado para su fill:#ddd claro). Blockly.Css.register
     apila hojas de estilo en vez de reemplazarlas, y como esta regla nunca
     pisaba fill-opacity, ese 0.8 del plugin seguia ganando — el negro salia
     lavado (80%) en vez de solido, como esta medido en el legacy real. */
  fill-opacity: 1;
}

.blocklyAngleMarks {
  stroke: #fff;
  /* Medido con getComputedStyle contra el legacy real: las marcas no son
     blanco solido, tienen stroke-opacity:0.5. */
  stroke-opacity: 0.5;
  stroke-width: 1;
}

.blocklyAngleGauge {
  fill: #fff;
  fill-opacity: 1;
  pointer-events: none;
}

.blocklyAngleLine {
  stroke: #fff;
  stroke-width: 1;
  pointer-events: none;
}

.blocklyAngleCenterPoint {
  fill: #fff;
  stroke: #fff;
  pointer-events: none;
}

.blocklyAngleDragHandle {
  fill: #fff;
  stroke: #fff;
  /* Medido con getComputedStyle contra el legacy real: el halo de la manija
     (el aro de 5px alrededor del circulo blanco solido) es semitransparente,
     no blanco solido — sin esto se ve como un borde duro en vez del
     "sombreado" difuso que tiene el legacy. */
  stroke-opacity: 0.25;
  stroke-width: 5;
  cursor: pointer;
}
`);
